<template>
  <section class="order">
    <template v-if="detail.orderid">
      <section class="status">
        <p>{{ detail.status_text }}</p>
        <van-count-down
          class="time"
          :time="detail.create_time | restTime"
          v-if="detail.status == 0"
        >
          <template #default="timeData">
            <template v-if="timeData.hours === 0 && timeData.minutes === 0 && timeData.seconds === 0">
              已超时
            </template>
            <template v-else>
              {{ timeData.hours }}时{{ timeData.minutes }}分{{ timeData.seconds }}秒
            </template>
          </template>
        </van-count-down>
        <!-- service_class = 1 && type = 2 不显示 lamp -->
        <small
          class="lamp"
          v-else-if="(detail.product_info.service_class != 1 || detail.product_info.type != 2) && detail.desc"
        >{{ detail.desc }}</small>
      </section>

      <section
        class="order-info"
        v-if="detail.product_info"
      >
        <!-- 修音品类 -->
        <template v-if="detail.product_info.service_class == 1">
          <div class="song">
            <div class="song-name">
              <h3>{{ detail.work_info.songname }}</h3>
              <p class="time">时长 {{ detail.work_info.seconds_text }}</p>
            </div>
            <div class="song-poster">
              <cover :src="detail.work_info.cover | avatar(100)" />
            </div>
          </div>
          <div class="service">
            <h4>服务类型-{{ detail.product_info.name }}</h4>
          </div>
        </template>
        <!-- 音乐教学品类 -->
        <template v-else-if="detail.product_info.service_class == 2">
          <div class="song">
            <div class="song-name">
              <h3>{{ detail.product_info.name }}</h3>
            </div>
            <div class="song-poster">
              <img
                :src="detail.product_info.other_attribute.icon"
                v-if="detail.product_info.other_attribute"
                alt=""
              >
            </div>
          </div>
        </template>

        <div class="price-wrapper price-box">
          <div class="total-price">
            <p class="total">
              <template v-if="detail.product_info.service_class == 1 && detail.product_info.type == 3">应付</template>
              <template v-else>总价</template>
            </p>
            <p class="price">¥{{ detail.money_detail.pay_money }}</p>
          </div>
        </div>

        <mall-transition-expand>
          <div
            class="more-wrapper"
            v-if="!orderCollapse"
          >
            <div class="price-box">
              <template v-if="detail.product_info.service_class != 1 || detail.product_info.type != 3">
                <div
                  class="total-price"
                  v-if="detail.activity_discount && detail.activity_discount.name"
                >
                  <p class="total">{{ detail.activity_discount.name }}</p>
                  <p class="price">¥{{ detail.activity_discount.activity_money }}</p>
                </div>
                <div
                  class="total-price"
                  v-else-if="isMoney(detail.money_detail.product_money)"
                >
                  <p class="total">服务价格</p>
                  <p class="price">¥{{ detail.money_detail.product_money }}</p>
                </div>
              </template>
              <div
                class="total-price"
                v-if="isMoney(detail.money_detail.final_payment)"
              >
                <p class="total">尾款</p>
                <p class="price">¥{{ detail.money_detail.final_payment }}</p>
              </div>
              <div
                class="total-price"
                v-if="isMoney(detail.money_detail.speedup_money)"
              >
                <p class="total">加急服务</p>
                <p class="price">¥{{ detail.money_detail.speedup_money }}</p>
              </div>
              <div
                class="total-price"
                v-if="isMoney(detail.money_detail.buff_money)"
              >
                <p class="total">服务包</p>
                <p class="price">¥{{ detail.money_detail.buff_money }}</p>
              </div>
              <div
                class="total-price"
                v-if="isMoney(detail.money_detail.again_money)"
              >
                <p class="total">付费修改</p>
                <p class="price">¥{{ detail.money_detail.again_money }}</p>
              </div>
              <div
                class="total-price"
                v-if="isMoney(detail.money_detail.coupon_money)"
              >
                <p class="total">优惠折扣</p>
                <p class="price">-¥{{ detail.money_detail.coupon_money }}</p>
              </div>
              <template v-if="detail.money_detail.refund_info">
                <div
                  class="total-price"
                  v-for="(item, index) in detail.money_detail.refund_info.product_money"
                  :key="`product-${index}`"
                >
                  <p class="total">服务退款</p>
                  <p class="price">-¥{{ item }}</p>
                </div>
                <div
                  class="total-price"
                  v-for="(item, index) in detail.money_detail.refund_info.deposit"
                  :key="`deposit-${index}`"
                >
                  <p class="total">定金退款</p>
                  <p class="price">-¥{{ item }}</p>
                </div>
                <div
                  class="total-price"
                  v-for="(item, index) in detail.money_detail.refund_info.deposit_final_payment"
                  :key="`deposit-final-${index}`"
                >
                  <p class="total">尾款退款</p>
                  <p class="price">-¥{{ item }}</p>
                </div>
                <div
                  class="total-price"
                  v-for="(item, index) in detail.money_detail.refund_info.buff_money"
                  :key="`buff-${index}`"
                >
                  <p class="total">加价退款</p>
                  <p class="price">-¥{{ item }}</p>
                </div>
                <div
                  class="total-price"
                  v-for="(item, index) in detail.money_detail.refund_info.again_money"
                  :key="`again-${index}`"
                >
                  <p class="total">返工退款</p>
                  <p class="price">-¥{{ item }}</p>
                </div>
                <div
                  class="total-price"
                  v-for="(item, index) in detail.money_detail.refund_info.speedup_money"
                  :key="`speedup-${index}`"
                >
                  <p class="total">加急退款</p>
                  <p class="price">-¥{{ item }}</p>
                </div>
              </template>
            </div>
            <div class="order-other">
              <h4>订单信息</h4>
              <p>订单号：CB{{ detail.orderid }}</p>
              <p>订单创建时间：{{ detail.create_time }}</p>
              <p>指定制作师：{{ detail.select_producer || '无' }}</p>
              <p>修音偏好：{{ detail.optional_note || '无' }}</p>
              <p v-if="detail.phone">联系方式：{{ detail.phone | mask }}</p>
            </div>
          </div>
        </mall-transition-expand>

        <div
          class="collapse"
          @click="orderCollapse = !orderCollapse"
          v-cbs="`订单金额-${orderCollapse ? '收起' : '展开'}`"
        >
          <div v-if="orderCollapse">
            展开
            <van-icon name="arrow-down" />
          </div>
          <div v-else>
            收起
            <van-icon name="arrow-up" />
          </div>
        </div>
      </section>

      <section
        class="payment"
        v-if="detail.status == 0"
      >
        <ul>
          <li
            v-for="(item, index) in paymentList"
            :class="item.type"
            :key="index"
          >
            <label class="custom-control">
              <input
                type="radio"
                name="payment"
                :value="item.type"
                v-model="paymentType"
                @change="handlePaymentChange(item)"
              >
              <div class="label">
                <div class="icon"></div>
                <div class="name">
                  <p>{{ item.name }}</p>
                  <small v-if="item.desc">{{ item.desc }}</small>
                </div>
                <div class="checkbox"></div>
              </div>
            </label>
          </li>
        </ul>
      </section>

      <section
        class="part-payment"
        v-if="detail.product_info.service_class == 1 && detail.product_info.type == 3 && (detail.status == 2 || detail.status == 4 || detail.status == 21)"
      >
        <h3>支付尾款</h3>
        <template v-if="detail.status == 21">
          <ul>
            <li>
              <div class="bd">
                <strong>尾款：¥{{ detail.money_detail.final_payment }}</strong>
              </div>
              <div class="ft">
                <small>满意请在7天内支付</small>
              </div>
            </li>
          </ul>
          <div class="action">
            <button
              type="button"
              class="btn"
              @click="cancelWorkDialog = true"
            >放弃成品</button>
            <button
              type="button"
              class="btn primary"
              @click="showDepositPaymentMenu = true"
            >立即支付</button>
          </div>
        </template>
        <template v-else>
          <ul>
            <li>
              <div class="bd">
                尾款：¥{{ detail.money_detail.final_payment }}
              </div>
              <div class="ft">
                <strong>等待成品</strong>
              </div>
            </li>
          </ul>
        </template>
      </section>

      <section
        class="preview"
        v-if="detail.product_info.service_class == 1 && detail.status > 0"
      >
        <div
          class="tabs"
          :class="{ single: !detail.other_material.length }"
        >
          <div
            class="tabs-item"
            :class="{ active: currentPreviewTab === 'work' }"
            @click="changeTab('work')"
          >作品展示</div>
          <div
            class="tabs-item"
            :class="{ active: currentPreviewTab === 'other' }"
            @click="changeTab('other')"
            v-if="detail.other_material.length"
          >补录素材</div>
        </div>

        <div class="tabs-content">
          <div
            class="tabs-content-item"
            :class="{ active: currentPreviewTab === 'work' }"
          >
            <h4>原作品：{{ detail.main_material.songname }}<small>{{ detail.main_material.create_time }}</small></h4>

            <mall-cool-player
              class="source"
              :src="detail.main_material.url"
              :cover="detail.work_info.song && detail.work_info.song.icon"
              stats="原作品"
            />
            <mall-cool-player
              class="pure"
              theme="2"
              :src="detail.main_material.gansheng_url"
              v-if="detail.main_material.gansheng_url"
              :cover="detail.work_info.song && detail.work_info.song.icon"
              stats="干声"
            />

            <div
              class="work-list"
              v-if="workDoneList.length"
            >
              <h4>成品交付</h4>
              <div class="release-banner">
                <img
                  src="~@cdn_img/post-production/banner.png"
                  alt=""
                >
              </div>
              <div
                class="prepare-tips"
                v-if="detail.product_info.service_class == 1 && detail.product_info.type == 3 && detail.status == 21"
              >
                支付尾款后即可获得无水印成品
              </div>
              <ul>
                <li
                  v-for="(item, index) in workDoneList"
                  :key="index"
                >
                  <mall-cool-player
                    theme="4"
                    :src="item.listen_url"
                    :cover="detail.work_info.song && detail.work_info.song.icon"
                    stats="成品"
                  />
                  <p>{{ item.create_time }}
                    <strong v-if="index === 0">
                      {{ isFirstManualSelectProducer ? `「制作师${firstManualSelectProducerName}」首次制作` : '首次上传' }}
                    </strong>
                    <strong v-else>第 {{ index + 1 }} 次上传</strong>
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div
            class="tabs-content-item"
            :class="{ active: currentPreviewTab === 'other' }"
          >
            <div class="work-list">
              <ul>
                <li
                  v-for="(item, index) in detail.other_material"
                  :key="index"
                >
                  <mall-cool-player
                    theme="3"
                    :src="item.url"
                    :cover="detail.work_info.song && detail.work_info.song.icon"
                    stats="备用"
                  />
                  <p>{{ item.create_time }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          class="preview-tips"
          v-if="detail.product_info.type == 4 && detail.original_material.length < 2"
        >
          <div
            class="tips-text"
            @click="selectSong"
            v-if="detail.show_text"
          >
            <div class="text">{{ detail.show_text }}</div>
            <button
              type="button"
              class="upload-button"
            >上传</button>
          </div>
          <div class="tips-content">
            上传你想修音的两个作品，为保证制作效果，仅支持单曲演唱（不支持合唱作品）。上传后制作师将开始为您制作
          </div>
          <div class="tips-action">
            <button
              type="type"
              class="btn"
              @click="selectSong"
            >上传自己作品</button>
            <router-link
              :to="`/work-selector/${id}`"
              tag="button"
              type="type"
              class="btn primary"
            >上传TA人作品</router-link>
          </div>
        </div>
        <div
          class="preview-tips"
          v-else
        >
          <div
            class="tips-text"
            @click="selectSong"
            v-if="detail.show_text"
          >
            <div class="text">{{ detail.show_text }}</div>
            <button
              type="button"
              class="upload-button"
            >上传</button>
          </div>
          <template v-if="workDoneList.length < 1">
            <div class="tips-content">
              <div
                class="prepare-tips"
                v-if="detail.product_info.service_class == 1 && detail.product_info.type == 3 && (detail.status == 2 || detail.status == 4)"
              >
                制作完成后可试听带水印作品
              </div>
              我们会以第一次上传的作品做为修音主素材！当作品有一些明显硬伤时，制作师会与您沟通重录或补录某些片段，以便成品有更完美效果，
              <span class="text-bolders">了解更多修音相关知识也欢迎咨询小唱哦～</span>
            </div>
            <div class="tips-link">
              <span
                class="text"
                @click="handleFollow"
              >点击跳转关注
                <van-icon name="arrow" />
              </span>
            </div>
          </template>
        </div>
      </section>

      <section
        class="lesson-info"
        v-if="detail.product_info.service_class == 2 && detail.status > 0 && detail.lesson_info.detail"
      >
        <div class="lesson-info-user">
          <div class="hd">
            <a :href="{ ac: 'personalpage', userid: detail.lesson_info.user.userid } | appProtocolUrl">
              <img :src="detail.lesson_info.user.headphoto | avatar">
            </a>
          </div>
          <div class="bd">
            <a :href="detail.lesson_info.jumpurl">
              <div class="nickname">
                <span class="text">{{ detail.lesson_info.user.nickname }}</span>
                <span
                  class="live"
                  v-if="detail.lesson_info.live_status == 1"
                >直播中</span>
              </div>
              <div
                class="vip"
                v-if="detail.lesson_info.user.vip > 0"
              >{{ detail.lesson_info.user.viptitle }}</div>
            </a>
          </div>
          <div class="ft">
            {{ detail.lesson_info.end_num }}/{{ detail.lesson_info.total_num }}<br>
            <span
              class="text"
              v-if="detail.product_info.type == 0"
            >已完成/总课时</span>
            <span
              class="text"
              v-if="detail.product_info.type == 1"
            >已完成/总场次</span>
          </div>
        </div>

        <mall-transition-expand>
          <div
            class="lesson-info-detail-wrapper"
            v-if="!lessonCollapse"
          >
            <div class="lesson-info-detail">
              <ol>
                <li
                  v-for="(item, index) in detail.lesson_info.detail"
                  :key="index"
                  :class="{ live: item.status == 3 }"
                  @click="playLesson(item)"
                >
                  <div class="time">{{ item.start_time | formatDate('YYYY-MM-DD HH:mm') }}-{{ item.end_time | formatDate('HH:mm') }}</div>
                  <div class="action">
                    <button
                      type="button"
                      class="btn"
                    >{{ item.status_text }}</button>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </mall-transition-expand>

        <div
          class="collapse"
          @click="lessonCollapse = !lessonCollapse"
        >
          <div v-if="lessonCollapse">
            展开
            <van-icon name="arrow-down" />
          </div>
          <div v-else>
            收起
            <van-icon name="arrow-up" />
          </div>
        </div>
      </section>
      <!-- 特殊处理id 56 -->
      <section
        class="service-center"
        v-if="detail.status != 0 && detail.product_info.id != 56"
      >
        <h3>服务中心</h3>
        <ul>
          <li
            v-if="detail.incr_price_info"
            @click="showPaymentMenu = true"
          >
            <div class="bd">
              <h4>购买服务包（¥{{ detail.incr_price_info.incr_price }}）</h4>
              <p><strong>支付后，制作师将开始工作</strong></p>
            </div>
            <div class="ft">
              <button
                type="button"
                class="mall-btn primary"
              >去支付</button>
            </div>
          </li>

          <!-- 大类 = 2 和 小类 = 1 的时候不显示这个模块 -->
          <!-- <template v-if="detail.product_info.service_class != 2 || detail.product_info.type != 1">
            <li @click="gotoUrl(detail.producer_chat_url)" v-if="orderStatusCondition(detail.status, [2, 4, 6, 7, 21])" v-cbs="{ name: '制作师留言', order_status: detail.status }">
              <div class="bd">
                <template v-if="detail.product_info.service_class == 1">
                  <h4>联系修音顾问</h4>
                  <p>有特殊制作要求？直接给修音顾问留言沟通</p>
                </template>
                <template v-else-if="detail.product_info.service_class == 2">
                  <h4>联系老师</h4>
                  <p>对课程有什么疑问？直接给老师留言沟通</p>
                </template>
              </div>
              <div class="ft">
                <button type="button" class="mall-btn">去联系</button>
              </div>
            </li>
          </template> -->

          <template v-if="detail.product_info.service_class == 1">
            <!-- <li v-if="orderStatusCondition(detail.status, [2, 4])" @click="openNote">
              <div class="bd">
                <h4>备注（填写你的修音需要）</h4>
                <p>完善你的修音需求，让制作师更懂你</p>
              </div>
              <div class="ft">
                <button type="button" class="mall-btn">去填写</button>
              </div>
            </li> -->

            <router-link
              tag="li"
              :to="`/apply-alter/${id}`"
              v-if="orderStatusCondition(detail.status, [6, 7])"
              v-cbs="'服务中心-修改服务'"
            >
              <div class="bd">
                <h4>修改服务</h4>
                <p>7 天内，不满意可修改</p>
              </div>
              <div class="ft">
                <button
                  type="button"
                  class="mall-btn"
                >去修改</button>
              </div>
            </router-link>

            <li
              @click="sendMail"
              v-cbs="{ name: '发送到邮箱', order_status: detail.status }"
              v-if="orderStatusCondition(detail.status, [10, 15])"
            >
              <div class="bd">
                <h4>发送成品到邮箱</h4>
                <p>填写邮箱地址，立即发送</p>
              </div>
              <div class="ft">
                <button
                  type="button"
                  class="mall-btn"
                >去填写</button>
              </div>
            </li>
          </template>

          <li
            @click="gotoUrl(detail.producer_chat_url || detail.cs_chat_url)"
            v-cbs="{ name: '联系修音顾问', order_status: detail.status }"
          >
            <div class="bd">
              <h4>联系修音顾问</h4>
              <p>订单遇到问题？联系修音顾问为您解决</p>
            </div>
            <div class="ft">
              <button
                type="button"
                class="mall-btn"
              >去联系</button>
            </div>
          </li>

          <li
            @click="cancelOrder"
            v-cbs="{ name: '取消订单', order_status: detail.status }"
            v-if="!isCancelTimeout && orderStatusCondition(detail.status, [2, 23, 4])"
          >
            <div class="bd">
              <h4>取消订单</h4>
              <p>支付 3 分钟内可取消</p>
            </div>
            <div class="ft">
              <button
                type="button"
                class="mall-btn"
              >去取消</button>
            </div>
          </li>

        </ul>
      </section>
      <section
        class="banner"
        v-if="banners.length > 0 "
      >
        <van-swipe
          autoplay="5000"
          indicator-color="#fff"
          width="100%"
        >
          <van-swipe-item
            v-for="(item, index) in banners"
            :key="index"
          >
            <a :href="item.jumpurl || 'javascript:;'">
              <img
                :src="item.img | replaceUrlProtocol"
                alt=""
              >
            </a>
          </van-swipe-item>
        </van-swipe>
      </section>
      <section
        class="footer"
        v-if="detail.product_info && (detail.status == 0 || detail.status == 6 || (detail.product_info.service_class == 1 && detail.status == 10)) "
      >
        <div class="inner">
          <div class="action">
            <div class="money">
              <p v-if="detail.status == 0">
                总计：<strong>¥{{ detail.money_detail.pay_money }}</strong>
              </p>
            </div>
            <div class="button">
              <!-- 特殊处理id 56 -->
              <router-link
                class="btn"
                :to="`/evaluation/${detail.orderid}`"
                v-cbs="'订单管理-评价'"
                v-if="detail.status == 6 && detail.product_info.id != 56"
              >评价</router-link>
              <template v-if="detail.product_info.service_class == 1 && (detail.status == 6 || detail.status == 10)">
                <button
                  type="button"
                  class="btn primary"
                  v-cbs="'订单管理-发布'"
                  v-if="workDoneList.length > 1"
                  @click="publish"
                >发布</button>
                <a
                  class="btn primary"
                  :href="{
                  ac: 'music_publish',
                  orderid: detail.orderid,
                  songname: detail.work_info.songname,
                  songcover: detail.work_info.cover
                } | appProtocolUrl"
                  v-cbs="'订单管理-发布'"
                  v-else
                  @click="stopAll"
                >发布</a>
              </template>
              <!-- 新增取消订单 -->
              <template v-if="detail.status == 0">
                <button
                  type="button"
                  class="btn cancel"
                  @click="cancelOrder"
                >
                  取消订单
                </button>
              </template>
              <template v-if="detail.status == 0">
                <button
                  type="button"
                  class="btn primary"
                  @click="handlePaymentDeposit"
                  v-cbs="{ name: '立即付款', product_id: detail.product_info.id }"
                  v-if="detail.product_info.service_class == 1 && detail.product_info.type == 3"
                >
                  立即付款
                </button>
                <button
                  type="button"
                  class="btn primary"
                  @click="payment"
                  v-cbs="{ name: '立即付款', product_id: detail.product_info.id }"
                  v-else
                >
                  立即付款
                </button>
              </template>
            </div>
          </div>
        </div>
      </section>

      <!-- <van-popup v-model="popupNote" closeable round position="bottom" close-icon="close" :style="{ height: '80%' }">
        <div class="mall-dialog note">
          <div class="mall-dialog-body">
            <dl v-if="note.note">
              <template v-for="(item, index) in note.note">
                <dt :key="`dt-${index}`">{{ item.name }}</dt>
                <dd :key="`dd-${index}`" v-if="item.maxnum > 1">
                  <mall-checkbox :maxnum="item.maxnum" v-model="noteData[item.id]" :lists="item.detail" />
                </dd>
                <dd :key="`dd-${index}`" v-else>
                  <mall-radio :name="`note-${item.id}`" :value="value.id" v-model="noteData[item.id]" v-for="(value, valueIndex) in item.detail" :key="valueIndex">{{ value.name }}</mall-radio>
                </dd>
              </template>
              <dt>其他备注</dt>
              <dd>
                <textarea placeholder="给制作师留言，告诉他你还有什么期望" v-model="otherNote"></textarea>
              </dd>
            </dl>
          </div>
          <div class="mall-dialog-footer">
            <button type="button" class="mall-dialog-button" @click="saveNote">确认</button>
          </div>
        </div>
      </van-popup> -->

      <van-popup
        v-if="detail.product_info"
        v-model="popupFinishedWorks"
        closeable
        round
        position="bottom"
        close-icon="close"
        :style="{ height: '80%' }"
        @close="closeFinishedWorks"
      >
        <div class="mall-dialog audio">
          <div class="mall-dialog-header">选择你要发布的单曲</div>
          <div class="mall-dialog-body">
            <ul class="audio-list">
              <li
                v-for="(item, index) in workDoneList"
                :key="index"
              >
                <div class="audio-time">{{ item.create_time }} 第 {{ index + 1 }} 次制作</div>
                <div class="audio-action">
                  <button
                    type="button"
                    class="btn"
                    @click="playAudio(item.listen_url, index)"
                    v-cbs="`成品列表弹窗-${curPlayIndex == index ? '播放' : '暂停' }`"
                  >{{ curPlayIndex == index ? '暂停' : '播放' }}</button>
                  <a
                    class="btn"
                    :href="{
                    ac: 'music_publish',
                    orderid: id,
                    workdoneid: item.id,
                    songname: detail.work_info.songname,
                    songcover: detail.work_info.cover
                  } | appProtocolUrl"
                    v-cbs="{ name: '成品列表弹窗-发布', make_number: index }"
                    @click="stopAll"
                  >发布</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </van-popup>

      <audio
        ref="audio"
        :src="audioUrl | replaceUrlProtocol"
      ></audio>

      <van-action-sheet
        v-model="showPaymentMenu"
        :actions="paymentList"
        cancel-text="取消"
        title="请选择支付方式"
        @select="gotoPayment"
      />
      <van-action-sheet
        v-model="showDepositPaymentMenu"
        :actions="paymentList"
        cancel-text="取消"
        title="请选择支付方式"
        @select="gotoDepositPayment"
      />

      <mall-player-dialog
        theme="video"
        :src="lessonSource"
        v-model="lessonPlayer"
        fullscreen
      />

      <van-dialog
        v-model="mailDialog"
        class-name="offset-top"
        width="400"
        title="请输入邮箱"
        show-cancel-button
        :before-close="setMail"
      >
        <div class="mobile-input-container">
          <input
            type="email"
            class="mobile-input"
            v-model.trim="email"
          >
        </div>
      </van-dialog>

      <van-dialog
        v-model="cancelDialog"
        width="350"
        title="请告诉我们取消原因，帮助我们做的更好"
        show-cancel-button
        confirm-button-text="确认取消"
        confirm-button-color="black"
        cancel-button-text="继续等待"
        cancel-button-color="#ff5046"
        :before-close="setCancelOrder"
      >
        <div class="cancel-container">
          <van-radio-group v-model="cancelReason">
            <van-radio
              v-for="(item, index) in cancelReasons"
              checked-color="#00CC90"
              :name="item"
              :key="index"
            >{{ item }}</van-radio>
          </van-radio-group>
        </div>
      </van-dialog>

      <van-dialog
        v-model="cancelWorkDialog"
        width="350"
        title="请告诉我们放弃的原因，帮助我们做的更好"
        show-cancel-button
        confirm-button-text="确认放弃"
        confirm-button-color="black"
        cancel-button-text="取消放弃"
        cancel-button-color="#ff5046"
        :before-close="setCancelWork"
      >
        <div class="cancel-container">
          <van-radio-group v-model="cancelWorkReason">
            <van-radio
              v-for="(item, index) in cancelWorkReasons"
              checked-color="#00CC90"
              :name="item"
              :key="index"
            >{{ item }}</van-radio>
          </van-radio-group>
        </div>
      </van-dialog>
    </template>
   <!-- 特殊处理id 56 -->
    <template v-if="detail.status != 0 && detail.product_info.id != 56">
      <section
        class="webchat-box"
        @click="drawTargetCoupon"
      >
        <img
          class="we-img"
          src="https://res.cdn.changbaimg.com/-/5f6f0b374a25d647/show-gift.png"
          alt=""
        >
      </section>
    </template>
  </section>
</template>

<script>
import Cover from "../components/Cover";
// import MallRadio from '../components/Radio';
// import MallNotice from '../components/Notice';
import MallPlayerDialog from "../components/PlayerDialog";
import MallTransitionExpand from "../components/TransitionExpand";
import MallCoolPlayer from "../components/CoolPlayer";
// import MallCheckbox from '../components/Checkbox';
import { gotoWebView, isHarmonyOS } from "../utils";

// import status from '../order-status';
// import { enums } from '@module/helper/filters';
import dayjs from "dayjs";
import qs from "qs";
import { trackElClickH5 } from '@changba/funny';


// 鸿蒙不显示微信支付
const getPaymentMap = () => {
  if (!isHarmonyOS()) {
    return {
      alipay: { name: '支付宝', type: 'alipay', desc: '' },
      weixin: { name: '微信', type: 'wechat', desc: '' }
    }
  }

  return {
    alipay: { name: '支付宝', type: 'alipay', desc: '' }
  }
}

const defaultPaymentMap = getPaymentMap();

export default {
  name: "Order",

  components: {
    Cover,
    // MallRadio,
    // MallNotice,
    MallPlayerDialog,
    MallTransitionExpand,
    MallCoolPlayer,
    // MallCheckbox
  },

  filters: {
    // orderStatus(value) {
    //   return enums(value, status);
    // },
    restTime(value) {
      return dayjs(value).add(15, "minute") - dayjs();
    },

    formatDate(value, format = "YYYY-MM-DD HH:mm:ss") {
      return dayjs(value).format(format);
    },

    mask(value) {
      return String(value).replace(/^(\d{3})(\d+)(\d{3})$/, "$1*****$3");
    },
  },

  props: {
    id: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      detail: {},
      orderCollapse: true,
      lessonCollapse: true,
      // popupNote: false,
      popupFinishedWorks: false,
      note: {},
      noteData: {},
      otherNote: "",

      switchPlayerIndex: 0,
      currentPreviewTab: "work",

      showPaymentMenu: false,
      showDepositPaymentMenu: false,

      paymentType: "alipay",
      // 服务端与前端支付数据之间的映射关系
      paymentMap: defaultPaymentMap,
      paymentList: [],

      workDoneList: [],
      audioUrl: "",
      curPlayIndex: -1,
      audio: "",

      lessonSource: "",
      lessonPlayer: false,

      banners: [],

      mailDialog: false,
      email: "",

      cancelDialog: false,
      cancelReason: "",
      cancelReasons: [
        "价格太高",
        "时间太长，不想等了",
        "重复下单",
        "歌曲选错了",
        "不想要了",
      ],

      cancelWorkDialog: false,
      cancelWorkReason: "",
      cancelWorkReasons: [
        "总价太贵了",
        "听不出制作前后的区别",
        "不如一键修音效果",
        "不想要了，换首歌再试试",
        "服务体验不好，回复速度慢",
      ],

      // 用户是否首次指定某制作师
      isFirstManualSelectProducer: false,
      firstManualSelectProducerName: "",
    };
  },

  computed: {
    isCancelTimeout() {
      let updateTime;

      if (
        this.detail.product_info.service_class == 1 &&
        this.detail.product_info.type == 3
      ) {
        // 定金品类
        updateTime = this.detail.money_detail?.pay_time?.deposit?.update_time;
      } else {
        // 其他品类
        updateTime =
          this.detail.money_detail?.pay_time?.product_money?.update_time;
      }

      if (updateTime) {
        // 3 分钟超时
        return dayjs().unix() - dayjs(updateTime).unix() > 60 * 3;
      } else {
        return true;
      }
    },

    workDoneStatus() {
      return this.orderStatusCondition(
        this.detail.status,
        [2, 4, 6, 7, 8, 9, 10, 15, 21]
      );
    },
  },

  created() {
    this.refresh();
  },
  methods: {
    handlePaymentChange(item) {
      trackElClickH5(`支付选择-${item.name}`, { money: this.detail.money_detail.pay_money });
    },
    saveStart() {
      this.timeOutEvent = setTimeout(() => {
        this.saveWechat();
      }, 500);
    },
    saveMove() {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    saveEnd() {
      clearTimeout(this.timeOutEvent);
    },
    saveWechat() {
      location.href =
        "changba://?ac=saveImage&imageURL=" +
        encodeURIComponent(
          "https://res.cdn.changbaimg.com/-/68bcea749a10981e/code-0-2.jpeg"
        );
    },
    handleFollow() {
      // 跳转官方
      window.location.href = "changba://?ac=personalpage&userid=293828578";
    },
    async refresh() {
      this.$toast.loading();

      const { code, data } = await this.$fetch(
        "/api/musicService/musicmall/getOrderInfo",
        {
          data: {
            orderid: this.id,
          },
        }
      );

      await this.getFinishedWorks();

      this.$toast.clear();

      if (code === 1) {
        // data.show_text = '测试一下';

        // 用于测试
        // if (data.status == 17) {
        //   data.status = 4;
        // }

        this.detail = data;

        // 处理支付顺序
        if (this.detail.pay_select?.length) {
          const result = [];

          this.detail.pay_select.forEach((item) => {
            // 鸿蒙不显示微信支付
            if (isHarmonyOS() && item.type === 'wechat') {
              return
            }
            const value = this.paymentMap[item.name];
            if (!value) {
              return;
            }
            value.desc = item.descstr;
            value.name = item.nickname;
            result.push(value);
          });

          this.paymentList = result;
          this.paymentType = this.paymentList[0].type;
        } else {
          this.paymentList = Object.values(this.paymentMap);
        }

        this.initAudio();

        // 复位备注数据
        this.note = {};

        this.getBanners();
      } else {
        // alert(window.location);
        const query = { ...this.$route.query };
        this.$router.replace({ path: "/", query }, () => {});
      }
    },

    isMoney(value) {
      return (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        !isNaN(Number(value))
      );
    },

    async getNote() {
      if (this.note.note) {
        return;
      }

      this.$toast.loading();

      const { code, data } = await this.$fetch(
        "/api/musicService/musicmall/getAgainSuggestion",
        {
          data: {
            productType: this.detail.product_info.type,
            productid: this.detail.product_info.id,
          },
        }
      );

      this.$toast.clear();

      if (code === 1) {
        this.note = data;
      }
    },

    // 新增 获取优惠券
    async drawTargetCoupon() {
      this.$toast.loading();

      const { code, msg } = await this.$fetch(
        "/api/musicService/musicmall/drawTargetCoupon",
        {
          method: "get",
        }
      );

      this.$toast.clear();

      if (code === 1) {
        this.$toast.success(msg || "优惠券已发放到用户的优惠券包中");
      } else {
        this.$toast.fail(msg);
      }
    },

    async getBanners() {
      const { code, data } = await this.$fetch(
        "/api/musicService/musicmall/getLivehouseBanner",
        {
          data: {
            service_class: this.detail.product_info.service_class,
            type: this.detail.product_info.type,
          },
        }
      );

      if (code == 1) {
        this.banners = data;
      }
    },

    // 普通支付
    async payment() {
      this.$toast.loading();

      const { code, data, msg } = await this.$fetch(
        "/api/musicService/musicmall/payOrder",
        {
          method: "post",
          data: {
            paytype: this.paymentType,
            orderid: this.id,
          },
        }
      );

      this.$toast.clear();

      if (code === 1) {
        gotoWebView(data, this.$router, true);
      } else {
        this.$toast.fail(msg);
      }
    },

    // 定金支付
    handlePaymentDeposit() {
      this.paymentDeposit(this.paymentType);
    },

    // 定金支付
    async paymentDeposit(paymentType, final = "no") {
      this.$toast.loading();

      const { code, data, msg } = await this.$fetch(
        "/api/musicService/musicmall/payOrderDeposit",
        {
          method: "post",
          data: {
            paytype: paymentType,
            orderid: this.id,
            is_final: final,
          },
        }
      );

      this.$toast.clear();

      if (code === 1) {
        gotoWebView(data, this.$router, true);
      } else {
        this.$toast.fail(msg);
      }
    },

    async payOther(paymentType) {
      this.$toast.loading();

      const { code, data, msg } = await this.$fetch(
        "/api/musicService/musicmall/payOther",
        {
          method: "post",
          data: {
            orderid: this.id,
            paytype: paymentType,
            service: "price",
            money: this.detail.incr_price_info.incr_price,
            incrid: this.detail.incr_price_info.id,
          },
        }
      );

      this.$toast.clear();

      if (code === 1) {
        gotoWebView(data, this.$router, true);
      } else {
        this.$toast.fail(msg);
      }
    },

    // async saveNote() {
    //   this.$toast.loading();

    //   const { code, msg } = await this.$fetch('/api/musicService/musicmall/createOrderNote', {
    //     method: 'post',
    //     data: {
    //       orderid: this.id,
    //       note: JSON.stringify(this.noteData),
    //       desc: this.otherNote
    //     }
    //   });

    //   this.$toast.clear();

    //   if (code === 1) {
    //     this.popupNote = false;
    //     this.$toast.success('提交成功');
    //   }
    //   else {
    //     this.$toast.fail(msg);
    //   }
    // },

    gotoPayment(item) {
      this.payOther(item.type);
      this.showPaymentMenu = false;
    },

    gotoDepositPayment(item) {
      this.paymentDeposit(item.type, "yes");
      this.showDepositPaymentMenu = false;
    },

    gotoUrl(url) {
      this.stopAll();
      window.location = url;
    },

    async getFinishedWorks() {
      const { code, data, msg } = await this.$fetch(
        "/api/musicService/musicmall/getOrderWorkDoneList",
        {
          data: {
            orderid: this.id,
          },
        }
      );

      if (code === 1) {
        this.workDoneList = data;
        const { select_producer, first_select } = msg;
        this.isFirstManualSelectProducer = first_select;
        this.firstManualSelectProducerName = select_producer;
      }
    },

    playAudio(url, index) {
      this.$refs.audio.pause();

      this.audioUrl = url;

      if (this.curPlayIndex == index) {
        this.curPlayIndex = -1;
      } else {
        this.curPlayIndex = index;
        this.$nextTick(() => {
          this.$refs.audio.play();
        });
      }
    },

    // openNote() {
    //   this.popupNote = true;

    //   // 解决 loading 被 popup 盖住的问题（后弹出的永远会遮住先弹出的）
    //   this.$nextTick(() => {
    //     this.getNote();
    //   });
    // },

    openFinishedWorks() {
      this.popupFinishedWorks = true;
    },

    closeFinishedWorks() {
      this.stopAll();
      trackElClickH5("成品列表弹窗-关闭");
    },

    stopAll() {
      this.$refs.playerBefore?.stop?.();
      this.$refs.playerAfter?.stop?.();
      this.$refs.audio?.pause?.();
      this.curPlayIndex = -1;
    },

    changeTab(name) {
      this.stopAll();
      this.currentPreviewTab = name;
    },

    publish() {
      this.stopAll();
      this.openFinishedWorks();
    },

    // 初始化作品选择弹窗的 audio 标签
    initAudio() {
      this.$nextTick(() => {
        this.$refs.audio.addEventListener("ended", () => {
          this.curPlayIndex = -1;
        });
      });
    },

    playLesson(item) {
      if (item.url) {
        if (item.status == 3) {
          window.location = item.url;
        } else {
          this.lessonSource = item.url;
          this.lessonPlayer = true;
        }
      }
    },

    selectSong() {
      const baseUrl = `${window.location.protocol}//${window.location.host}${this.$router.options.base}`;
      const params = qs.stringify({
        orderid: this.id,
      });
      const redirectUrl = `${baseUrl}/work-uploader?${params}`;

      // mediatype 表示音频或视频，0: 音频，1: 视频
      window.location = `changba://?ac=manual_correct_music&mediatype=${
        this.detail.product_info.type == 1 ? 1 : 0
      }&redirecturl=${encodeURIComponent(redirectUrl)}`;
    },

    sendMail() {
      this.email = "";
      this.mailDialog = true;
    },

    async setMail(action, done) {
      if (action !== "confirm") {
        done();
        return;
      }

      if (
        !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.email
        )
      ) {
        this.$toast.fail("请输入正确的邮箱");
        done(false);
        return;
      }

      const { code, msg } = await this.$fetch(
        "/api/musicService/musicmall/sendEmail",
        {
          method: "post",
          data: {
            email: this.email,
            orderid: this.id,
          },
        }
      );

      if (code === 1) {
        this.$toast.success("发送成功");
        done();
      } else {
        this.$toast.fail(msg);
        done(false);
      }
    },

    cancelOrder() {
      this.$dialog
        .alert({
          title: "要放弃拥有优质作品吗？",
          message: `支付3分钟内，如果您觉得不再需要可以取消订单<br>取消后钱会在3个工作日内原路退回到您的账户<br>如有使用优惠，也将自动退回，您可以再次下单使用`,
          showCancelButton: true,
          cancelButtonText: "我知道了",
          confirmButtonText: "确认取消",
          confirmButtonColor: "black",
          cancelButtonColor: "#ff5046",
          messageAlign: "left",
          width: 350,
        })
        .then(() => {
          this.cancelReason = "";
          this.cancelDialog = true;
        })
        .catch(() => {});
    },

    async setCancelOrder(action, done) {
      if (action !== "confirm") {
        done();
        return;
      }

      if (!this.cancelReason) {
        this.$toast.fail("请选择取消原因");
        done(false);
        return;
      }

      let url = "/api/musicService/musicmall/cancelOrder";

      // 已支付
      if (
        !this.isCancelTimeout &&
        this.orderStatusCondition(this.detail.status, [2, 23, 4])
      ) {
        url = "/api/musicService/musicmall/cancelOrderByUser";
      }

      const { code, msg } = await this.$fetch(url, {
        method: "post",
        data: {
          reason: this.cancelReason,
          orderid: this.id,
        },
      });

      if (code === 1) {
        this.refresh();
        this.$toast.success("取消成功");
        done();
        this.$router.replace({ path: "/homes/post-production" });
      } else {
        this.$toast.fail(msg);
        done(false);
      }
    },

    async setCancelWork(action, done) {
      if (action !== "confirm") {
        done();
        return;
      }

      if (!this.cancelWorkReason) {
        this.$toast.fail("请选择取消原因");
        done(false);
        return;
      }

      const { code, msg } = await this.$fetch(
        "/api/musicService/musicmall/giveUpDeposit",
        {
          method: "post",
          data: {
            reason: this.cancelWorkReason,
            orderid: this.id,
          },
        }
      );

      if (code === 1) {
        this.refresh();
        this.$toast.success("取消成功");
        done();
        this.$router.replace({ path: "/homes/post-production" });
      } else {
        this.$toast.fail(msg);
        done(false);
      }
    },

    orderStatusCondition(value, conditions) {
      return conditions.includes(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@cdn_js/styles/order.scss";

.order .payment li {
  &:first-child {
    margin-top: 0;
  }
}
</style>
